export default "__VITE_ASSET__fc3d7bc7__"